import axiosInstance from "../app/axios";
import ServiceTypeDTO from "../shared/dtos/serviceTypeDTO";

interface PaginatedProps {
  page?: number;
  take?: number;
  search?: string;
}

export const getServiceTypeList = async () => {
  const PAGE_SIZE = 100;

  const fetchPage = async (page: number) => {
    const res = await axiosInstance.get("service-types", {
      params: { page, take: PAGE_SIZE },
      headers: { "x-hide-success": true },
    });
    return res.data;
  };

  const first = await fetchPage(1);
  const items = [...first.data];
  const total = first.total;

  if (total > PAGE_SIZE) {
    const pages = Math.ceil(total / PAGE_SIZE);
    const results = await Promise.all(
      Array.from({ length: pages - 1 }, (_, i) => fetchPage(i + 2)),
    );
    for (const r of results) {
      items.push(...r.data);
    }
  }

  return items;
};

export const getServiceTypePaginatedList = async ({
  page = 1,
  take = 10,
  search = "",
}: PaginatedProps) => {
  const result = await axiosInstance.get(
    `service-types?page=${page}&take=${take}${
      search ? `&search=${search}` : ""
    }`,
  );
  return result.data;
};

export const deleteServiceType = async (id: number) => {
  const result = await axiosInstance.delete(`service-types/${id}`);
  return result.data;
};

export const getServiceType = async (id: number) => {
  const result = await axiosInstance.get(`service-types/${id}`);
  return result.data[0];
};

export const createServiceType = async (serviceTypeDTO: ServiceTypeDTO) => {
  const result = await axiosInstance.post("service-types", {
    name: serviceTypeDTO.name,
    calculator: serviceTypeDTO.calculator,
    capacity: serviceTypeDTO.capacity,
    luggageCount: serviceTypeDTO.luggageCount,
    distance: serviceTypeDTO.distance,
    fixed: serviceTypeDTO.fixed,
    minute: serviceTypeDTO.minute,
    price: serviceTypeDTO.price,
    image: serviceTypeDTO.image,
    managerImage: serviceTypeDTO.managerImage,
    type: serviceTypeDTO.type,
    serviceClass: serviceTypeDTO.serviceClass,
    internationalPercentage: serviceTypeDTO.internationalPercentage,
    sortOrder: serviceTypeDTO.sortOrder,
  });
  return result.data[0];
};

export const patchServiceType = async (
  serviceTypeDTO: ServiceTypeDTO,
  serviceTypeId: number,
) => {
  const result = await axiosInstance.patch(`service-types/${serviceTypeId}`, {
    name: serviceTypeDTO.name,
    calculator: serviceTypeDTO.calculator,
    capacity: serviceTypeDTO.capacity,
    luggageCount: serviceTypeDTO.luggageCount,
    distance: serviceTypeDTO.distance,
    fixed: serviceTypeDTO.fixed,
    minute: serviceTypeDTO.minute,
    price: serviceTypeDTO.price,
    image: serviceTypeDTO.image,
    managerImage: serviceTypeDTO.managerImage,
    type: serviceTypeDTO.type,
    internationalPercentage: serviceTypeDTO.internationalPercentage,
    sortOrder: serviceTypeDTO.sortOrder,
  });
  return result.data[0];
};

export const getNextSortOrder = async () => {
  const result = await axiosInstance.get("service-types/next-order");
  return result.data;
};

export const reorderServiceTypes = async (
  items: { id: number; sortOrder: number }[],
) => {
  const result = await axiosInstance.post("service-types/reorder", items);
  return result.data;
};

export const patchServiceTypeActiveForAllAdmins = async (
  serviceTypeId: number,
  isActiveForAllAdmins: boolean,
) => {
  const result = await axiosInstance.patch(
    `service-types/${serviceTypeId}/isactiveforadmins`,
    {
      isActiveForAllAdmins,
    },
  );
  return result.data[0];
};
